export default __webpack_public_path__ + "3b1c68dca301532d3877cf8c46a25072.svg";